import * as React from "react";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "./form";

/**
 * FormHookField component
 * 
 * A wrapper component that bridges react-hook-form's Controller with our custom FormField components
 */
interface FormHookFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  control: Control<TFieldValues>;
  name: TName;
  label?: string;
  render: (props: { field: any }) => React.ReactNode;
}

export function FormHookField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  render,
}: FormHookFieldProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormField name={name}>
          <FormItem>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              {render({ field })}
            </FormControl>
            {fieldState?.error?.message && (
              <FormMessage>{fieldState.error.message}</FormMessage>
            )}
          </FormItem>
        </FormField>
      )}
    />
  );
}
